import { render, staticRenderFns } from "./ExpediaSetupForm.vue?vue&type=template&id=0340066a&scoped=true&"
import script from "./ExpediaSetupForm.vue?vue&type=script&lang=js&"
export * from "./ExpediaSetupForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0340066a",
  null
  
)

export default component.exports